import { Row, Col } from 'antd';
import {
  useGetVitalsParameterListQuery,
  VitalsParameterOutput,
  DonationOutput,
  LabworkOutput,
} from 'gql/types';
import { Alert, Spin } from 'modules/common/components';
import { useDebounceValue } from 'modules/common/hooks/useDebounceValue';
import { getDonationAlerts } from 'modules/donations/components/CreateDonationAlerts/alerts';
import { CreateDonationSchemaType } from 'modules/donations/components/CreateDonationForm/schema';
import { IVitalsParameters } from 'modules/donor/components/UpdateVitalsParametersModal/interface';
import { getParametersValues } from 'modules/donor/components/UpdateVitalsParametersModal/utils';
import { FC, useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

type Props = {
  previousDonationData?: DonationOutput;
  lastLabwork?: LabworkOutput;
};

export const CreateDonationAlerts: FC<Props> = ({
  previousDonationData,
  lastLabwork,
}) => {
  const { data, loading: gettingVitalsParameters } =
    useGetVitalsParameterListQuery();
  const parametersValues: IVitalsParameters =
    data?.getVitalsParameterList &&
    getParametersValues(
      data?.getVitalsParameterList as VitalsParameterOutput[]
    );
  const form = useFormContext();

  const watchedValues = useWatch({
    control: form.control,
  }) as CreateDonationSchemaType;

  const debouncedValues = useDebounceValue(watchedValues, 1200);

  const donationAlerts = getDonationAlerts(
    parametersValues,
    debouncedValues,
    previousDonationData,
    lastLabwork
  );
  const isAlertToDisplayExisted = donationAlerts.some(({ rule }) => rule());
  useEffect(() => {
    form.setValue(
      'vitalsSection.donationInfo.shouldDonate',
      !isAlertToDisplayExisted
    );
  }, [isAlertToDisplayExisted]);

  return (
    <Spin spinning={gettingVitalsParameters}>
      <Row gutter={[0, 10]}>
        {donationAlerts.map((value) => {
          return (
            value.rule() && (
              <Col span={24} key={value.message}>
                <Alert
                  style={{ alignItems: 'center' }}
                  type="warning"
                  message={value.message}
                  description={value.description}
                  showIcon
                  closable
                />
              </Col>
            )
          );
        })}
      </Row>
    </Spin>
  );
};
